module.exports = __webpack_public_path__ + "img/yingyu.9a98ed2c.png";